var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHealthinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.986 29.166h.028a.532.532 0 00.306-.096c.227-.157 4.378-3.059 7.45-6.253h-3.561a.848.848 0 01-.75-.447l-1.41-2.658-1.672 4.729a.846.846 0 01-.837.558.843.843 0 01-.783-.631l-1.604-6.351-1.401 4.226a.845.845 0 01-.805.574h-2.716c3.072 3.194 7.223 6.096 7.45 6.253.092.065.2.096.305.096z",
    fill: "#0F0449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.763 21.15c-.33-.415-.626-.829-.88-1.235l-.01-.017A5.883 5.883 0 019 16.814c0-3.298 2.737-5.98 6.102-5.98A6.14 6.14 0 0120 13.246a6.141 6.141 0 014.899-2.414c3.364 0 6.101 2.683 6.101 5.981a5.882 5.882 0 01-.883 3.1c-.253.407-.55.82-.88 1.237h-4.515l-2.078-3.918a.849.849 0 00-.812-.445.844.844 0 00-.738.557l-1.38 3.905-1.63-6.451a.843.843 0 00-.79-.632.846.846 0 00-.835.574l-2.125 6.41h-3.571z",
    fill: "#0F0449"
  })));
}

export default SvgHealthinline;